import React, { useRef, useState } from 'react';
// import Slider from 'react-slick';
import PropTypes from 'prop-types';

import {
  EditIconNew,
  NewBackArrowIconEventPage,
  NewNextArrowIconEventPage,
} from '../../../utils/icons';
import MedalCard from './MedalCard';
import { CompanyMedalCardsSliderContainer, SliderContainerV2 } from './styles';
import dayjs from 'dayjs';

/* ---------------- Slider Wrapper ---------------- */

const CompanyMedalCardsSlider = ({ companyRewardDetails = [],onRewardTierEdit }) => {
  const sliderRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);

  const slidesToShow = 4;
  const allTiersLength = (companyRewardDetails || []).reduce(
    (total, config) => total + (config?.tiers?.length || 0),
    0
  );
  const totalPages = Math.max(
    1,
    // Math.ceil(companyRewardDetails?.length / slidesToShow)
    Math.ceil(allTiersLength / slidesToShow)
  );

  const goNext = () => {
    if (currentPage < totalPages) {
      sliderRef.current?.slickNext();
      setCurrentPage((p) => p + 1);
    }
  };

  const goPrev = () => {
    if (currentPage > 1) {
      sliderRef.current?.slickPrev();
      setCurrentPage((p) => p - 1);
    }
  };

  //   const sliderSettings = {
  //     infinite: false,
  //     speed: 300,
  //     slidesToShow,
  //     slidesToScroll: slidesToShow,
  //     arrows: false,
  //     dots: false,
  //     responsive: [
  //       {
  //         breakpoint: 1024,
  //         settings: { slidesToShow: 2 },
  //       },
  //       {
  //         breakpoint: 640,
  //         settings: { slidesToShow: 1 },
  //       },
  //     ],
  //   };

  //   if (!companyRewardDetails?.tiers?.length) return null;

  const formattedDate = () => {
    const data = companyRewardDetails?.[currentPage - 1];
    const startDate = data?.start_date;
    const endDate = data?.end_date;
  
    if (!startDate || !endDate) return "";
  
    // If active is false → show only start date as "MMMM YYYY"
    if (data?.active === false) {
      return `${dayjs(startDate).format("MMMM D, YYYY")} - ${dayjs(endDate).format("MMMM D, YYYY")}`;
    }
  
    // Otherwise → show range
    return `${dayjs(startDate).format("MMMM D, YYYY")} - ${dayjs(endDate).format("MMMM D, YYYY")}`;
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const onEditTier = ()=>{
    const currentData = companyRewardDetails?.[currentPage - 1];
    onRewardTierEdit(currentData)
    // if(currentData?.tier_type === 'custom'){
    //     history.push({pathname:,state:{isEdit:true,periodId:currentData?.period_id}})
    // }else{
    //     showTierConfig()
    // }
    
  }

  return (
    <CompanyMedalCardsSliderContainer totalPages={totalPages}>
      {/* Navigation */}
      {totalPages > 1 ? (
        <div
          className='heading'
        >
          <div className='heading-text'>{companyRewardDetails?.[currentPage - 1]?.active ? "Rewards :":'Upcoming Years Rewards:' } {formattedDate()}
            {!companyRewardDetails?.[currentPage - 1]?.active ? <span
              className="edit"
              onClick={() => onEditTier()}
              title="Edit"
            >
              {EditIconNew()}
            </span>:null}
          </div>
          <div className='pagination'>
            {currentPage > 1 && (
              <div onClick={goPrev} className='arrow'>
                {NewBackArrowIconEventPage('#DA6C74')}
              </div>
            )}
  
            <span className='page-details'>
              {currentPage}/{totalPages}
            </span>
  
            {currentPage < totalPages && (
              <div onClick={goNext} className='arrow'>
                {NewNextArrowIconEventPage('#DA6C74')}
              </div>
            )}
          </div>
        </div>
      ):(companyRewardDetails.length === 1 && !companyRewardDetails?.[0]?.active && companyRewardDetails?.[0]?.end_date && !dayjs(companyRewardDetails?.[0]?.end_date).isBefore(dayjs(), "day"))  ? <div className='upcoming'> Starts from: {formattedDate()} </div> :null}

      {/* Slider */}
      <SliderContainerV2 mulitiPage={totalPages > 1}>
        {companyRewardDetails?.[currentPage-1]?.tiers?.map((tier,index)=>
          <div className='single-card' key={index}><MedalCard tier={tier} /></div>)}
      </SliderContainerV2>
      {totalPages > 1 && (
        <div className="dots-container">
          {Array.from({ length: totalPages }).map((_, index) => {
            const pageNumber = index + 1;
            return (
              <div
                key={pageNumber}
                className={`dot ${currentPage === pageNumber ? 'active' : ''}`}
                onClick={() => goToPage(pageNumber)}
              />
            );
          })}
        </div>
      )}
    </CompanyMedalCardsSliderContainer>
  );
};

/* ---------------- PropTypes ---------------- */

CompanyMedalCardsSlider.propTypes = {
  companyRewardDetails: PropTypes.array,
  onRewardTierEdit:PropTypes.func
};

export default CompanyMedalCardsSlider;
